/**
 * Homepage reviews-carousel — laadt Google + Trustpilot via tracker API.
 * 3 kaarten zichtbaar (desktop), slide per pagina.
 */
(function () {
  'use strict';

  var API_DEFAULT = 'https://tracker.urbanfloors.nl/api/reviews';

  var STAR_ON =
    '<svg class="uf-home-review-slide__star" width="18" height="18" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M8 1.2l1.76 3.56 3.93.57-2.84 2.77.67 3.91L8 10.16l-3.52 1.85.67-3.91L2.31 5.33l3.93-.57L8 1.2z"/></svg>';
  var STAR_OFF =
    '<svg class="uf-home-review-slide__star uf-home-review-slide__star--empty" width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M8 1.2l1.76 3.56 3.93.57-2.84 2.77.67 3.91L8 10.16l-3.52 1.85.67-3.91L2.31 5.33l3.93-.57L8 1.2z" stroke="currentColor" stroke-width="1.2"/></svg>';

  var LOGO_GOOGLE =
    '<svg class="uf-home-review-slide__source-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>' +
    '<path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>' +
    '<path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>' +
    '<path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>' +
    '</svg>';

  var LOGO_TRUSTPILOT =
    '<svg class="uf-home-review-slide__source-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path fill="#00B67A" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>' +
    '</svg>';

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function starsHtml(n) {
    var full = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += i <= full ? STAR_ON : STAR_OFF;
    }
    return (
      '<div class="uf-home-review-slide__stars" aria-label="' +
      full +
      ' van 5 sterren">' +
      out +
      '</div>'
    );
  }

  function sourceBadgeHtml(source) {
    var isGoogle = source === 'google';
    var label = isGoogle ? 'Google' : 'Trustpilot';
    var logo = isGoogle ? LOGO_GOOGLE : LOGO_TRUSTPILOT;
    return (
      '<span class="uf-home-review-slide__source" data-source="' +
      escapeHtml(source) +
      '">' +
      '<span class="uf-home-review-slide__source-logo">' +
      logo +
      '</span>' +
      '<span class="uf-home-review-slide__source-name">' +
      escapeHtml(label) +
      '</span>' +
      '</span>'
    );
  }

  function formatRelativeDate(raw) {
    if (!raw) return '';
    var d = new Date(raw);
    if (isNaN(d.getTime())) return '';
    var now = new Date();
    var diffDays = Math.floor((now - d) / 86400000);
    if (diffDays < 0) diffDays = 0;
    if (diffDays === 0) return 'Vandaag';
    if (diffDays === 1) return 'Gisteren';
    if (diffDays < 7) return diffDays + ' dagen geleden';
    if (diffDays < 30) {
      var w = Math.floor(diffDays / 7);
      return w === 1 ? '1 week geleden' : w + ' weken geleden';
    }
    if (diffDays < 365) {
      var m = Math.floor(diffDays / 30);
      return m === 1 ? '1 maand geleden' : m + ' maanden geleden';
    }
    var y = Math.floor(diffDays / 365);
    return y === 1 ? '1 jaar geleden' : y + ' jaar geleden';
  }

  function byDateDesc(a, b) {
    var da = a.date ? new Date(a.date).getTime() : 0;
    var db = b.date ? new Date(b.date).getTime() : 0;
    return db - da;
  }

  function sourceReviews(data, source, key) {
    var list = [];
    if (!data || !data[key] || !Array.isArray(data[key].reviews)) return list;
    data[key].reviews.forEach(function (item, i) {
      if (!item || !item.text) return;
      list.push({
        id: item.id || key + '-' + i,
        author: item.author || 'Anoniem',
        stars: item.stars || 5,
        title: item.title || '',
        text: item.text,
        date: item.date || '',
        url: item.url || (data[key] && data[key].url) || '',
        source: source
      });
    });
    list.sort(byDateDesc);
    return list;
  }

  /** Google en Trustpilot om en om (nieuwste per bron eerst). */
  function interleaveReviews(a, b) {
    var out = [];
    var i = 0;
    var j = 0;
    var takeA = true;
    while (i < a.length || j < b.length) {
      if (takeA && i < a.length) {
        out.push(a[i++]);
      } else if (!takeA && j < b.length) {
        out.push(b[j++]);
      } else if (i < a.length) {
        out.push(a[i++]);
      } else if (j < b.length) {
        out.push(b[j++]);
      }
      takeA = !takeA;
    }
    return out;
  }

  function collectReviews(data) {
    var google = sourceReviews(data, 'google', 'google');
    var trustpilot = sourceReviews(data, 'trustpilot', 'trustpilot');
    return interleaveReviews(google, trustpilot);
  }

  function cardHtml(item) {
    var dateLabel = formatRelativeDate(item.date);
    var href = item.url || '';
    var open =
      href
        ? '<a class="uf-home-review-slide__link" href="' +
          escapeHtml(href) +
          '" target="_blank" rel="noopener noreferrer">'
        : '<div class="uf-home-review-slide__link">';
    var close = href ? '</a>' : '</div>';

    return (
      '<article class="uf-home-review-slide" role="listitem" data-source="' +
      escapeHtml(item.source) +
      '">' +
      open +
      '<div class="uf-home-review-slide__top">' +
      starsHtml(item.stars) +
      sourceBadgeHtml(item.source) +
      '</div>' +
      (item.title
        ? '<h3 class="uf-home-review-slide__title">' + escapeHtml(item.title) + '</h3>'
        : '') +
      '<p class="uf-home-review-slide__text">' +
      escapeHtml(item.text) +
      '</p>' +
      '<div class="uf-home-review-slide__meta">' +
      '<span class="uf-home-review-slide__author">' +
      escapeHtml(item.author) +
      '</span>' +
      (dateLabel
        ? '<time class="uf-home-review-slide__date" datetime="' +
          escapeHtml(item.date) +
          '">' +
          escapeHtml(dateLabel) +
          '</time>'
        : '') +
      '</div>' +
      close +
      '</article>'
    );
  }

  function mountCarousel(slider) {
    slider.setAttribute('data-uf-home-carousel', '');
    var prev = slider.querySelector('[data-uf-carousel-prev]');
    var next = slider.querySelector('[data-uf-carousel-next]');
    if (prev) prev.hidden = false;
    if (next) next.hidden = false;
    if (window.UFHomeCarousel && typeof window.UFHomeCarousel.init === 'function') {
      window.UFHomeCarousel.init(slider);
    }
  }

  function renderEmpty(section, message) {
    var track = section.querySelector('[data-uf-home-reviews-track]');
    if (!track) return;
    track.innerHTML =
      '<p class="uf-home-reviews__empty">' + escapeHtml(message) + '</p>';
  }

  function render(section, data) {
    var track = section.querySelector('[data-uf-home-reviews-track]');
    var slider = section.querySelector('[data-uf-home-reviews-slider]');
    if (!track || !slider) return;

    var reviews = collectReviews(data);
    if (!reviews.length) {
      renderEmpty(section, 'Reviews zijn tijdelijk niet beschikbaar.');
      return;
    }

    track.innerHTML = reviews.map(cardHtml).join('');
    mountCarousel(slider);
  }

  function bootSection(section) {
    if (!section || section.getAttribute('data-uf-reviews-bound') === '1') return;
    section.setAttribute('data-uf-reviews-bound', '1');

    var api = section.getAttribute('data-uf-reviews-api') || API_DEFAULT;
    var ufFetch =
      window.UF_OFFLINE && typeof window.UF_OFFLINE.fetch === 'function'
        ? window.UF_OFFLINE.fetch
        : fetch;
    ufFetch(api, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('reviews ' + res.status);
        return res.json();
      })
      .then(function (data) {
        render(section, data);
      })
      .catch(function () {
        renderEmpty(section, 'Reviews zijn tijdelijk niet beschikbaar. Probeer het later opnieuw.');
      });
  }

  function boot(scope) {
    var parent = scope && scope.nodeType === 1 ? scope : document;
    parent.querySelectorAll('[data-uf-home-reviews]').forEach(bootSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
